import { Box, Flex, Button, Spacer, HStack } from '@chakra-ui/react'
import { FC } from 'react'
import { IMeshData, IModelDesignData } from '../../../../../type/designType'
import { IMesh } from '../../../../../type/modelType'
import { switchingVariant } from '../../../../../utils/design/customization'

interface IProps {
  mesh: IMesh
  designData: IModelDesignData
  setMeshData: (meshData: IMeshData) => void
}

const fieldSetStyle = {
  padding: 0,
  paddingBlock: '15px',
  borderTop: '1px solid #E2E8F0',
}

const legendStyle = {
  paddingRight: '15px',
}

const buttonSx = {
  width: '100%',
  marginLeft: '10px',
  _hover: {
    color: 'white',
    bg: 'black',
  },
}

export const SwitchingVariantPanel: FC<IProps> = ({
  mesh,
  designData,
  setMeshData,
}) => {
  const meshData = designData.modelConfig.meshes.find(
    m => mesh.id === m.id
  ) as IMeshData

  return (
    <Box>
      <fieldset style={fieldSetStyle}>
        <legend style={legendStyle}>Variants</legend>
        <HStack spacing="2">
          {mesh.variants
            .filter(v => v.isOption)
            .map(variant => (
              <Button
                key={`switch-variant-${variant.id}`}
                sx={buttonSx}
                size="sm"
                onClick={() => {
                  switchingVariant(variant.meshName, mesh.variants)
                  setMeshData({
                    ...meshData,
                    variants: [
                      {
                        id: variant.id,
                      },
                    ],
                  })
                }}
              >
                {variant.title}
              </Button>
            ))}

          {mesh.canHideMesh && (
            <Button
              sx={buttonSx}
              size="sm"
              onClick={() => {
                switchingVariant(false, mesh.variants)
                setMeshData({
                  ...meshData,
                  variants: [],
                })
              }}
            >
              No {mesh.title}
            </Button>
          )}
        </HStack>
      </fieldset>
    </Box>
  )
}
